import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { useApi } from '@/lib/api-context';

import { auditSummaryResponseSchema, type AuditSummary } from './types';

interface Options {
  companyId: string | null;
  enabled: boolean;
}

/** KPIs de la bitácora de la empresa activa (hoy/mes/firmas/devoluciones).
 *  queryKey por empresa; valida el contrato con Zod. */
export function useAuditSummary({ companyId, enabled }: Options): UseQueryResult<AuditSummary> {
  const api = useApi();
  return useQuery({
    queryKey: ['audit-summary', companyId],
    queryFn: async () => {
      const raw = await api.get<unknown>('/api/v1/audit-logs/summary');
      return auditSummaryResponseSchema.parse(raw).data;
    },
    enabled,
  });
}
